<div class="create-subscription">
    <form nz-form [formGroup]="form" (ngSubmit)="submit()">
        <nz-form-item>
            <nz-form-label [nzSpan]="6" nzRequired>Product</nz-form-label>
            <nz-form-control
                [nzSpan]="18"
                [nzErrorTip]="'Please select a product'"
                [nzValidateStatus]="form.get('product')"
            >
                <nz-input-group nzSearch nzSize="large" class="w-full">
                    <input
                        placeholder="Find a product"
                        nz-input
                        (input)="onChange($event)"
                        formControlName="productSearch"
                        [nzAutocomplete]="auto"
                    />
                </nz-input-group>
                <nz-autocomplete #auto>
                    <nz-auto-option
                        *ngFor="let product of filteredProducts"
                        [nzValue]="product.label"
                        (selectionChange)="fieldSelected($event, product)"
                    >
                        <div class="global-search-item">
                            <div>
                                <div class="font-bold">
                                    {{ product.label }}
                                </div>
                                <div
                                    *ngIf="product.subLabel"
                                    class="subscription-product-sublabel"
                                >
                                    {{ product.subLabel }}
                                </div>
                            </div>
                        </div>
                    </nz-auto-option>
                </nz-autocomplete>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label [nzSpan]="6" nzRequired>Current cycle</nz-form-label>
            <nz-form-control [nzSpan]="18" [nzErrorTip]="currentCycleErrorTip">
                <nz-input-number
                    formControlName="currentCycle"
                    nzMin="1"
                    nzMax="999"
                    nzPlaceHolder="1"
                    style="width: 100%"
                ></nz-input-number>
                <small class="next-cycle-charge" *ngIf="nextCycleChargeMessage">
                    {{ nextCycleChargeMessage }}
                </small>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label [nzSpan]="6" nzRequired
                >Next cycle date</nz-form-label
            >
            <nz-form-control
                [nzSpan]="18"
                [nzErrorTip]="'Please select a next cycle date'"
            >
                <nz-date-picker
                    formControlName="nextCycleDate"
                    nzFormat="yyyy-MM-dd"
                    style="width: 100%"
                    nzPlaceHolder="Select date"
                    [nzDisabledDate]="disablePastAndTodayDates"
                ></nz-date-picker>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label [nzSpan]="6">Extras</nz-form-label>
            <nz-form-control [nzSpan]="18">
                <lite-json-editor formControlName="extras"></lite-json-editor>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-control [nzSpan]="24" [nzOffset]="6">
                <div class="flex gap-2">
                    <button
                        nz-button
                        nzType="default"
                        (click)="close()"
                        type="button"
                    >
                        Cancel
                    </button>
                    <button
                        nz-button
                        nzType="primary"
                        type="submit"
                        [nzLoading]="isSubmitting"
                    >
                        Create subscription
                    </button>
                </div>
            </nz-form-control>
        </nz-form-item>
    </form>
</div>
